class AdpMainHeaderController {
  constructor() {
    this.name = 'adpMainHeader';
  }
}

export default AdpMainHeaderController;



// WEBPACK FOOTER //
// ./src/app/components/adpMainHeader/adpMainHeader.controller.js